export default __webpack_public_path__ + "static/media/Web-Pic1.18a2cef0.svg";